var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1 11.4C16.4 11.1 16.4 10.8 16.1 10.5L12.8 7.1C12.6 7.1 12.5 7 12.3 7C12.1 7 12 7.1 11.8 7.2C11.5 7.5 11.5 7.8 11.8 8.1L14.1 10.4H6.39999C5.99999 10.4 5.79999 10.7 5.79999 11C5.79999 11.3 6.09999 11.6 6.39999 11.6H14.1L11.8 13.9C11.5 14.2 11.5 14.5 11.8 14.8C12.1 15.1 12.4 15.1 12.7 14.8L16.1 11.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22 16.9V5.1C22 2.3 19.7 0 16.9 0H5.1C2.3 0 0 2.3 0 5.1V16.9C0 19.7 2.3 22 5.1 22H16.9C19.7 22 22 19.7 22 16.9ZM20.7 16.9C20.7 19 19 20.7 16.9 20.7H5.1C3 20.7 1.3 19 1.3 16.9V5.1C1.3 3 3 1.3 5.1 1.3H16.9C19 1.3 20.7 3 20.7 5.1V16.9Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.4892f148e7c284a004c74c43e7764484.svg";
export { ForwardRef as ReactComponent };